import React, { useState } from 'react';

import { AttentionMessage } from '@eika/attention-message';

import { NavigationButtons } from '../../../../components/shared/NavigationButtons';
import useTranslation from '../../../../hooks/useTranslation';
import useFormContext from '../../form/useFormContext';
import { validateSelectedEfakturas } from '../../form/validate';
import useCanIBeHere from '../../hooks/useCanIBeHere';
import routes from '../../routes';
import { CreditorPanels } from '../CreditorPanels';

import './EfakturaSelectList.scss';

const EfakturaSelectList: React.FC = () => {
    const translated = useTranslation();
    const {
        form: { state, curryChange },
    } = useFormContext();

    const [validationMessage, setValidationMessage] = useState<string>();

    useCanIBeHere(['name', 'ssn', 'amountSelected'], '');

    const validateSelectedCreditors = () => {
        const message = validateSelectedEfakturas(translated, state);
        setValidationMessage(message.selected);
        return !message.selected;
    };

    return (
        <section className="efaktura-sharing__select-list-wrapper">
            <CreditorPanels
                selected={state.selected}
                onChange={curryChange('selected')}
                setValidationMessage={setValidationMessage}
            />
            {validationMessage && <AttentionMessage type="error" text={validationMessage} />}
            <NavigationButtons
                className="efaktura-sharing__navigation-buttons"
                centerOnSmallerWidth
                onClick={validateSelectedCreditors}
                nextUrl={routes.summary}
                cancelUrl={routes.cancel}
            />
        </section>
    );
};

export default EfakturaSelectList;
